import {
  mdiCalendarClock,
  mdiClockOutline,
  mdiEye,
  mdiImageOutline,
  mdiPencilOutline,
} from '@mdi/js';
import Icon from '@mdi/react';
import Project2LightIcon from 'components/LightIcons/Project2Light';
import React from 'react';

// mdi `size` and the custom icon's MUI fontSize are matched so both icons render
// at roughly the same size — tweak together.
const MDI_SIZE = 0.85;

// First icon — the verb (what the user did). VIEW => eye.
const VERB_ICON_PATHS = {
  VIEW: mdiEye,
  EDIT: mdiPencilOutline,
};

// Second icon — the feature/target. Either an mdi path string or a custom
// SvgIcon component (e.g. the project icon used on the project dashboard).
const TARGET_ICONS = {
  PROJECT: Project2LightIcon,
  TIMESTAMPS: mdiCalendarClock,
  RECORD: mdiClockOutline,
  IMAGE: mdiImageOutline,
};

const renderIcon = (icon) => {
  if (!icon) {
    return null;
  }
  if (typeof icon === 'string') {
    return <Icon path={icon} size={MDI_SIZE} />;
  }
  const TargetIcon = icon;
  return <TargetIcon fontSize="small" />;
};

/**
 * The two row icons for an activity-log action of the form VERB_TARGET
 * (e.g. VIEW_PROJECT, VIEW_TIMESTAMPS, EDIT_PROJECT): the verb icon (eye for VIEW)
 * and the feature icon (custom project icon for PROJECT, calendar for TIMESTAMPS).
 * Unknown verbs/targets render nothing for that slot, so new actions degrade
 * gracefully until their icons are added here.
 */
export const getActivityLogIcons = (action = '') => {
  const [verb, ...targetParts] = String(action).split('_');
  const target = targetParts.join('_');

  return {
    verbIcon: renderIcon(VERB_ICON_PATHS[verb]),
    targetIcon: renderIcon(TARGET_ICONS[target]),
  };
};
